import React, { Component } from 'react';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import MainStore from '../../../MainStore';
import { observer } from 'mobx-react';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ServerStore from './ServerStore';
import EnvironmentProductTable from '../Projects/EnvironmentProductTable';
import StandTypeSelect from './StandTypeSelect';
import RedisServerSelect from './RedisServerSelect';
import RedisDBSelect from './RedisDBSelect';
import { fetchWithAuth } from '../../Auth/GlobalFetchWithAuth';
import ServerSelect from './ServerSelect';
import UserSelect from '../Users/UserSelect';

const EnvironmentDialog = observer(class EnvironmentDialog extends Component {
    constructor() {
        super();
        this.state = {
            selectedTab: 0
        };
        this.handleClose = this.handleClose.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleRowDataChange = this.handleRowDataChange.bind(this);
    };

    handleTabChange(event, newValue) {
        this.setState({ "selectedTab": newValue });
    }

    handleRowDataChange = name => evt => {
        var rowData = ServerStore.openedEnvironment;
        rowData[name] = evt.target.value;
        ServerStore.setOpenedEnvironment(rowData);
    };

    handleLookupChange = name => value => {
        var server = ServerStore.openedEnvironment;
        server[name + "Id"] = value.id;
        server[name + "Name"] = value.name;
        ServerStore.setOpenedEnvironment(server);
    }

    handleClose() {
        ServerStore.closeServerEnvironment();
    }

    handleSave() {
        MainStore.setMaskVisible();
        fetchWithAuth(
            'api/Server/SaveServerApp',
            JSON.stringify(ServerStore.openedEnvironment)
            ,
            'application/json',
            (result) => {
                MainStore.setMaskUnvisible();
                ServerStore.environmentUpdateHandler(result);
                ServerStore.closeServerEnvironment();
            },
            'POST'
        );
    }

    render() {
        return (
            <div>
                <Dialog
                    onClose={this.handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={ServerStore.isEnvironmentOpened}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
                        Добавление новой среды
                    </DialogTitle>
                    <DialogContent dividers>
                        <AppBar position="static" color="default">
                            <Tabs
                                value={this.state.selectedTab}
                                onChange={this.handleTabChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="scrollable"
                                scrollButtons="auto"
                            >
                                <Tab label="Информация" />
                                <Tab label="Продукты" />
                            </Tabs>
                        </AppBar>
                        {this.state.selectedTab === 0 && <div className="card-inner-block">
                            <Grid container spacing={2} justifyContent="center">
                                <Grid item xs={12}>
                                    <TextField required
                                        id="standard-required"
                                        label="Название"
                                        fullWidth
                                        variant="standard"
                                        margin="normal"
                                        value={ServerStore.openedEnvironment.name}
                                        onChange={this.handleRowDataChange('name')} />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField required
                                        id="standard-required"
                                        label="URL"
                                        defaultValue="http://"
                                        fullWidth
                                        variant="standard"
                                        margin="none"
                                        value={ServerStore.openedEnvironment.url}
                                        onChange={this.handleRowDataChange('url')} />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField required
                                        id="standard-required"
                                        label="Внешний адрес"
                                        defaultValue=""
                                        margin="none"
                                        fullWidth
                                        variant="standard"
                                        value={ServerStore.openedEnvironment.externalUrl}
                                        onChange={this.handleRowDataChange('externalUrl')} />
                                </Grid>
                                <Grid item xs={12}>
                                    <StandTypeSelect name={ServerStore.openedEnvironment.typeName} id={ServerStore.openedEnvironment.typeId} label="Тип" handleSelect={this.handleLookupChange("type")} />
                                </Grid>
                                <Grid item xs={6}>
                                    <ServerSelect name={ServerStore.openedEnvironment.sqlServerName} id={ServerStore.openedEnvironment.sqlServerId} label="SQL Сервер" handleSelect={this.handleLookupChange("sqlServer")} accountId={ServerStore.openedEnvironment.accountId}/>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField required
                                        id="standard-required"
                                        label="Название БД"
                                        defaultValue=""
                                        fullWidth
                                        variant="standard"
                                        margin="none"
                                        value={ServerStore.openedEnvironment.sqlDB}
                                        onChange={this.handleRowDataChange('sqlDB')} />
                                </Grid>
                                <Grid item xs={6}>
                                    <RedisServerSelect name={ServerStore.openedEnvironment.redisServerName} id={ServerStore.openedEnvironment.redisServerId} label="Сервер Redis" handleSelect={this.handleLookupChange("redisServer")}  />
                                </Grid>
                                <Grid item xs={6}>
                                    <RedisDBSelect name={ServerStore.openedEnvironment.redisDbName} id={ServerStore.openedEnvironment.redisDbId} redisServerId={ServerStore.openedEnvironment.redisServerId} label="База Redis" handleSelect={this.handleLookupChange("redisDb")} />
                                </Grid>
                                <Grid item xs={6}>
                                    <ServerSelect name={ServerStore.openedEnvironment.serverName} id={ServerStore.openedEnvironment.serverId} label="Сервер" handleSelect={this.handleLookupChange("server")} accountId={ServerStore.openedEnvironment.accountId}/>
                                </Grid>
                                <Grid item xs={6}>
                                    <UserSelect name={ServerStore.openedEnvironment.ownerName} id={ServerStore.openedEnvironment.ownerId} label="Ответственный" handleSelect={this.handleLookupChange("owner")} />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField required
                                        id="standard-required"
                                        label="Бинарные файлы"
                                        defaultValue=""
                                        margin="none"
                                        fullWidth
                                        variant="standard"
                                        value={ServerStore.openedEnvironment.binPath}
                                        onChange={this.handleRowDataChange('binPath')} />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField required
                                        id="standard-required"
                                        label="Логин"
                                        defaultValue=""
                                        margin="none"
                                        fullWidth
                                        variant="standard"
                                        value={ServerStore.openedEnvironment.login}
                                        onChange={this.handleRowDataChange('login')} />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField required
                                        id="standard-required"
                                        label="Пароль"
                                        defaultValue=""
                                        margin="none"
                                        fullWidth
                                        variant="standard"
                                        value={ServerStore.openedEnvironment.password}
                                        onChange={this.handleRowDataChange('password')} />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField required
                                        id="standard-required"
                                        label="Токен"
                                        defaultValue=""
                                        margin="none"
                                        fullWidth
                                        variant="standard"
                                        value={ServerStore.openedEnvironment.token}
                                        onChange={this.handleRowDataChange('token')} />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField required
                                        id="standard-required"
                                        label="Примечания"
                                        defaultValue=""
                                        margin="normal"
                                        fullWidth
                                        variant="standard"
                                        multiline
                                        value={ServerStore.openedEnvironment.notes}
                                        onChange={this.handleRowDataChange('notes')} />
                                </Grid>
                            </Grid>
                        </div>}
                        {this.state.selectedTab === 1 && <div className="card-inner-block">
                            <EnvironmentProductTable environmentId={ServerStore.openedEnvironment.id} />
                        </div>
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleSave} color="primary">
                            Сохранить
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
});

export default EnvironmentDialog;